<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'eSignature'"
      [canGoBack]="true"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true">

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (windowService.isDesktopRes) {
      <!-- Page title + tab switcher, mirroring the Contacts page. The per-tab header
           below carries that tab's description and its one action. -->
      <tidy-desktop-header class="no-bottom-margin">
        <div class="wrappable-container e-sign-header-row">
          <tidy-text [title]="'eSignature'" />
          <tidy-tabs
            [tabs]="tabTabs"
            [activeTab]="tab"
            (tabChange)="selectTab($event)" />
        </div>
      </tidy-desktop-header>

      <tidy-desktop-header [isLoading]="!loaded">
        <div class="wrappable-container">
          @if (tab === 'sent') {
            <tidy-text [header]="'Sent Documents'" />
            <tidy-text [helper]="'Send documents for signature and track their status.'" />
            <tidy-small-button
              [text]="'Send for Signature'"
              [image]="'assets/img/add-button-white.svg'"
              (buttonClick)="sendForSignature()" />
          }
          @if (tab === 'templates') {
            <tidy-text [header]="'Templates'" />
            <tidy-text [helper]="'Reusable documents for leases, addenda and notices.'" />
            <tidy-small-button
              [text]="'Add Template'"
              [image]="'assets/img/add-button-white.svg'"
              (buttonClick)="addTemplate()" />
          }
        </div>
        <div class="non-wrappable-right-aligned-container">
          <automations-preview-button
            [tag]="'e-sign'" />
        </div>
      </tidy-desktop-header>
    }

    @if (!loaded) {
      <div style="display: flex; gap: 8px; margin-bottom: 14px;">
        <ion-skeleton-text animated="true" style="height: 30px; width: 140px; border-radius: 16px" />
        <ion-skeleton-text animated="true" style="height: 30px; width: 110px; border-radius: 16px" />
      </div>
      @for (i of [1,2,3,4]; track i) {
        <div style="width: 100%; margin-bottom: 8px;">
          <ion-skeleton-text animated="true" style="height: 80px; border-radius: 6px" />
        </div>
      }
    }

    @if (loaded) {

      <!-- Desktop renders the tabs inside the title header instead. -->
      @if (!windowService.isDesktopRes) {
        <tidy-tabs
          style="display: block; margin-bottom: 16px;"
          [tabs]="tabTabs"
          [activeTab]="tab"
          (tabChange)="selectTab($event)" />
      }

      <!-- ============ SENT DOCUMENTS ============ -->
      @if (tab === 'sent') {
        @if (!windowService.isDesktopRes) {
          <tidy-row class="extra-bottom-padding">
            <tidy-button
              [text]="'Send for Signature'"
              [action]="sendForSignatureAction"
              class="primary" />
          </tidy-row>
        }
        @if (envelopeRows.length) {
          <tidy-table
            [dataSource]="envelopeRows"
            [displayedColumns]="envelopeHeaders"
            [columnslabels]="envelopeHeaders"
            [allRowIsClickable]="true"
            [rowsToShow]="50"
            [showColumnLines]="false"
            (cellClick)="onEnvelopeClick($event)"
            [blockSorting]="true" />
        }
        @if (envelopeRows.length === 0) {
          <tidy-alert><tidy-row><tidy-text [body]="emptyStateText" /></tidy-row></tidy-alert>
        }
      }

      <!-- ============ TEMPLATES ============ -->
      @if (tab === 'templates') {
        @if (!windowService.isDesktopRes) {
          <tidy-row class="extra-bottom-padding">
            <tidy-button [text]="'Add Template'" [action]="addTemplateAction" class="primary" />
          </tidy-row>
        }
        @if (templateRows.length) {
          <tidy-table
            [dataSource]="templateRows"
            [displayedColumns]="templateHeaders"
            [columnslabels]="templateHeaders"
            [allRowIsClickable]="true"
            [rowsToShow]="50"
            [showColumnLines]="false"
            (cellClick)="onTemplateClick($event)"
            [blockSorting]="true" />
        }
        @if (templateRows.length === 0) {
          <tidy-alert><tidy-row><tidy-text [body]="emptyStateText" /></tidy-row></tidy-alert>
        }
      }
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content" />
